import React from 'react';

import { SVGComponentProps } from './svg.types';

const EmbedViewSVG = ({
  size = '1em',
  fill = 'currentColor',
  ...otherProps
}: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="80 226 915.66 771.2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <rect width="100%" height="100%" fill="none"></rect>
      <path
        fill={fill}
        d="M2.85.44a.526.526 0 00-.599.44L.711 10.96a.525.525 0 101.038.16L3.29 1.04a.525.525 0 00-.44-.6z"
        transform="translate(506.471 500) scale(48.7326) translate(-2 -6)"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill={fill}
        d="M4.144 7.07L1.247 4 4.144.93a.525.525 0 00-.763-.72L.143 3.64a.525.525 0 000 .72l3.238 3.43a.523.523 0 00.742.021.525.525 0 00.021-.742z"
        transform="translate(500 500) translate(-2.144 -4)"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill={fill}
        d="M4.144 7.07L1.247 4 4.144.93a.525.525 0 00-.763-.72L.143 3.64a.525.525 0 000 .72l3.238 3.43a.523.523 0 00.742.021.525.525 0 00.021-.742z"
        transform="translate(204.729 500) scale(56.1549) translate(-2.144 -4)"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill={fill}
        d="M4.144 7.07L1.247 4 4.144.93a.525.525 0 00-.763-.72L.143 3.64a.525.525 0 000 .72l3.238 3.43a.523.523 0 00.742.021.525.525 0 00.021-.742z"
        transform="matrix(-56.1549 0 0 56.1549 795.271 500) translate(-2.144 -4)"
        vectorEffect="non-scaling-stroke"
      ></path>
    </svg>
  );
};

export default EmbedViewSVG;
